import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme) => {
  return {
    container: {
      background: "#fff",
      padding: "32px 24px",
      margin: "16px 0",

      minWidth: '1206px',
      // maxWidth: '1206px',

      boxShadow:
        "0px 0px 2px rgba(0, 0, 0, 0.12), 0px 2px 2px rgba(0, 0, 0, 0.24)",
      borderRadius: "4px",
    },
    statusContainer: {
      display: 'flex',
      justifyContent: 'space-between'
    },
    resetPass: {
      '& button': {
        marginLeft: '16px',
        color: '#2F80ED',
        '& .MuiCircularProgress':{
          marginRight: '5px'
        }
      }
    },
    content: {
      alignItems: "flex-start",
      justifyContent: "space-between",

      display: "flex",
      background: "#fff",
      gap: "80px",

      width: "100%",
      minWidth: '1024px',
      maxWidth: '1206px',
      minHeight: "160px",
    },
    statusInfo: {
      display: 'flex',
      alignItems: 'center',
      marginBottom: '32px',
      '& .MuiTypography-body2': {
        color: '#73BB94',
        fontSize: '0.62rem',
        marginRight: '16px'
      },
      '& .badge': {
        backgroundColor: '#007582',
        color: '#fff',
        padding: '5px 16px',
        borderRadius: '15px'
      }
    },
    nameContainer: {
      minWidth: "300px",
      width: "350px",
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
    },
    nameText: {
      fontSize: "24px",
      fontWeight: 700,
    },
    truncateText: {
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis'
    },
    reasonDisapproval: {
      wordWrap: 'break-word',
      overflow: 'hidden'
    },
    infoContainer: {
      width: "100%",
      minWidth: "650px",
      display: "flex",
      justifyContent: "space-between",
      alignItems: "flex-start",
      gap: "10px",
    },
    firstColumn: {
      display: 'flex',
      flexDirection: 'column',
      gap: '20px'
    },
    secondColumn: {
      display: 'flex',
      flexDirection: 'column',
      gap: '20px'
    },
    thirdColumn: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'flex-start',
      gap: '20px'
    },
    info: {
      display: "flex",
      flexDirection: "column",
      fontSize: "12px",
      "& .label": {
        whiteSpace: "pre",
      },
      "& .wrong": {
        fontWeight: 700,
      },
    },
    btn: {
      display: "flex",
      gap: 15,
      "& .check": {
        border: "3px #7C9E3D solid",
        color: "#7C9E3D",
        padding: 2,
      },
      "& .close": {
        border: "3px #D63C43 solid",
        color: "#D63C43",
        padding: 2,
      },
    },
    modal: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
    modalContainer: {
      background: "#000",
      color: "#fff",
      width: "490px",
      minHeight: "210px",
      padding: "32px",
      textAlign: "center",
    },
    titleModal: {
      fontSize: "24px",
      fontWeight: 700,
      marginBottom: "16px",
    },
    textodal: {
      fontSize: "14px",
      color: "#C4C4C4",
      fontWeight: 400,
      paddingBottom: '20px'
    },
    inputModal: {
      margin: "24px 0",
      background: "#fff",
      color: "#000",
    },
    btnModal: {
      display: "flex",
      width: "100%",
      justifyContent: "center",
      alignItems: "center",
      gap: "24px",
      "& button": {
        padding: "16px 24px",
      },
      "& .cancel": {
        background: "#999",
        color: "#666",
      },
    },
    infoModalUserContainer: {
      display: 'flex',
      justifyContent: 'space-between',
      width: '100%',
      margin: '32px auto',

      '& .label': {
        color: '#c4c4c4',
        fontWeight: 400
      },

      '& .wrong': {
        color: '#fff',
        fontWeight: 700
      }
    }
  };
});
